import type { TGetSimulacoesRelacionadas } from '@/features/simulacao/interfaces/simulacao.type'

type TSelecaoProdutoPropostaValidadorBase = {
  simulacoes: TGetSimulacoesRelacionadas['relacionadas']
  simulacaoSelecionada: TGetSimulacoesRelacionadas['relacionadas'][number]
}

export abstract class SelecaoProdutoPropostaValidadorBase {
  protected readonly simulacoes: TGetSimulacoesRelacionadas['relacionadas']
  protected readonly simulacaoSelecionada: TGetSimulacoesRelacionadas['relacionadas'][number]
  protected readonly textoDinamicoTipoProduto: string

  constructor({ simulacoes, simulacaoSelecionada }: TSelecaoProdutoPropostaValidadorBase) {
    this.simulacoes = simulacoes
    this.simulacaoSelecionada = simulacaoSelecionada
    this.textoDinamicoTipoProduto =
      simulacaoSelecionada.tipoDoProduto === 'Acessorio' ? 'este acessório' : 'esta unidade'
  }

  protected existeMaisDeUmaSimulacaoDoProdutoSelecionada(): boolean {
    const LIMITE_PRODUTOS_IGUAIS = 1

    return (
      this.simulacoes.filter((simulacao) => simulacao.produto.idExterno === this.simulacaoSelecionada.produto.idExterno)
        .length >= LIMITE_PRODUTOS_IGUAIS
    )
  }

  protected simulacaoSelecionadaPossuiParcelaVencida(): boolean {
    return this.simulacaoSelecionada.possuiParcelaVencida
  }

  abstract validate(): string | null
}
